<!-- Dar süzgeç panellerinde de sığsın diye düğmeler grup değil, satır sonunda kayıyor. -->
<div class="d-flex flex-wrap gap-1" role="group" aria-label="Tarih aralığı">
  <button type="button" class="btn btn-sm text-nowrap quick-day" *ngFor="let option of quickDays"
          [class.btn-primary]="isQuickDayActive(option.date)"
          [class.btn-outline-secondary]="!isQuickDayActive(option.date)"
          [ngbTooltip]="option.title" container="body"
          (click)="selectQuickDay(option.date)">{{ option.label }}</button>
  <!-- Gri gün düğmeleri arasında kaybolmasın diye kapalıyken de mavi çerçeveli. -->
  <button type="button" class="btn btn-sm text-nowrap fw-semibold"
          [class.btn-primary]="customOpen"
          [class.btn-outline-primary]="!customOpen"
          ngbTooltip="Başlangıç ve bitişi ayrı ayrı seç" container="body"
          (click)="toggleCustom()">
    <i class="bx bx-calendar-edit me-1"></i>Özel
  </button>
  <button type="button" class="btn btn-sm btn-outline-secondary" *ngIf="hasValue"
          ngbTooltip="Tarih süzgecini kaldır" container="body" (click)="clear()">
    <i class="bx bx-x"></i>
  </button>
</div>

<div class="d-flex align-items-center gap-1 mt-1" *ngIf="customOpen">
  <div class="input-group input-group-sm">
    <input class="form-control" placeholder="Başlangıç" ngbDatepicker #startPicker="ngbDatepicker"
           autocomplete="off" [maxDate]="end" [ngModel]="start" (ngModelChange)="onStartChange($event)">
    <button class="btn btn-outline-secondary" type="button" (click)="startPicker.toggle()">
      <i class="bx bx-calendar"></i>
    </button>
  </div>
  <span class="text-muted">–</span>
  <div class="input-group input-group-sm">
    <input class="form-control" placeholder="Bitiş" ngbDatepicker #endPicker="ngbDatepicker"
           autocomplete="off" [minDate]="start" [ngModel]="end" (ngModelChange)="onEndChange($event)">
    <button class="btn btn-outline-secondary" type="button" (click)="endPicker.toggle()">
      <i class="bx bx-calendar"></i>
    </button>
  </div>
</div>
